import {
  AMBIENT_SCRIBE_STATUS_AWAITING_UPLOAD,
  AMBIENT_SCRIBE_STATUS_PAUSED,
  AMBIENT_SCRIBE_STATUS_PROCESSING,
  AMBIENT_SCRIBE_STATUS_RECORDING,
  AMBIENT_SCRIBE_STATUS_RETRYING,
  AMBIENT_SCRIBE_STATUS_TRANSCRIBED,
  AMBIENT_SCRIBE_STATUS_UPLOADED,
  AMBIENT_SCRIBE_STATUS_UPLOADING
} from "features/medical-scribe/medical-scribe-constants";

export const AUDIO_DOWNLOAD_COPY = {
  download: "Download Audio",
  preparing: "Preparing audio…",
  downloading: "Downloading…",
  preparingCaption:
    "Getting the audio ready. This can take up to 2 minutes. Keep this window open.",
  localOnlyCaption:
    "Downloads the copy saved on this computer while recording.",
  checking: "Checking this computer…",
  serverItem: "Download Server Audio",
  // No format here: when the MP3 can't be made, the original recording is downloaded instead.
  serverItemNote: "The full recording, saved in Suno.",
  localItem: "Download Local Audio",
  noLocalCopy: "This computer has no saved copy of this recording.",
  localCopyNote:
    "Saved on this computer while recording. It may be missing parts of the visit.",
  moreOptions: "More download options",
  completeFirst: "Complete this scribe to download its audio.",
  notReadyYet:
    "You can download the audio once this scribe finishes processing.",
  noAudio: "There is no audio to download for this scribe."
} as const;

const NOT_READY_STATUSES = new Set([
  AMBIENT_SCRIBE_STATUS_RECORDING,
  AMBIENT_SCRIBE_STATUS_AWAITING_UPLOAD,
  AMBIENT_SCRIBE_STATUS_UPLOADING,
  AMBIENT_SCRIBE_STATUS_UPLOADED,
  AMBIENT_SCRIBE_STATUS_PROCESSING,
  AMBIENT_SCRIBE_STATUS_TRANSCRIBED,
  AMBIENT_SCRIBE_STATUS_RETRYING
]);

/** Why there is nothing to download, from the scribe's FE status. */
export function audioUnavailableReason(status: number | undefined): string {
  if (status === AMBIENT_SCRIBE_STATUS_PAUSED)
    return AUDIO_DOWNLOAD_COPY.completeFirst;
  if (status !== undefined && NOT_READY_STATUSES.has(status)) {
    return AUDIO_DOWNLOAD_COPY.notReadyYet;
  }
  return AUDIO_DOWNLOAD_COPY.noAudio;
}
